var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 m-0"},[_c('Libre')],1)}
var staticRenderFns = []

export { render, staticRenderFns }